import { render, staticRenderFns } from "./MfcAdviserEnrolment.vue?vue&type=template&id=305cd686"
import script from "./MfcAdviserEnrolment.vue?vue&type=script&lang=js"
export * from "./MfcAdviserEnrolment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports